'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosTennisball = function IoIosTennisball(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm3.5 19.7z m16.6 16.6z m-0.3-32.5c8.9 0 16.2 7.2 16.2 16.2 0 0.6 0 1.3-0.1 1.9-0.8 7.6-7 13.6-14.6 14.3-0.5 0.1-1 0.1-1.6 0.1-8.9 0-16.2-7.3-16.2-16.3v-0.3c0-0.5 0-0.9 0.1-1.3 0.7-7.5 6.7-13.7 14.3-14.6 0.4 0 0.8 0 1.2 0h0.7z m-9.8 17.1c2 0.7 3.7 2 5.3 3.6s2.8 3.2 3.6 5.3c0.6 1.6 1.1 3.4 1.2 5.1 0.4 0 0.8 0 1.2-0.1-0.2-4.1-1.9-8.2-5.1-11.3s-7.2-4.8-11.3-5.1c-0.1 0.4-0.1 0.9-0.1 1.3 1.7 0.1 3.5 0.5 5.2 1.2z m13-4.2c3.2 3.2 7.3 4.9 11.5 5.2 0.1-0.4 0.1-0.9 0.1-1.3-1.9-0.1-3.6-0.4-5.3-1.1-2-0.8-3.8-2.1-5.4-3.6s-2.8-3.4-3.6-5.4c-0.7-1.8-1.1-3.5-1.2-5.3-0.4 0-0.8 0-1.2 0 0.2 4.3 1.9 8.3 5.1 11.5z' })
        )
    );
};

exports.default = IoIosTennisball;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-tennisball.js
// module id = 2328
// module chunks = 0